import { createContext } from 'react';

export const MenuMobileContext = createContext({
  isOpen: false,
  setIsOpenAction: (isOpen: boolean) => {},
});
